import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=4c060b5d&scoped=true&"
import script from "./sample.vue?vue&type=script&lang=js&"
export * from "./sample.vue?vue&type=script&lang=js&"
import style0 from "./sample.vue?vue&type=style&index=0&id=4c060b5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c060b5d",
  null
  
)

export default component.exports